/*
 * @Author: huangzq
 * @Date: 2020-04-13 21:23:10
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-04-26 15:45:58
 * @Desc: 商学院使用的基本编辑布局组件
*/
<template>
  <div class="mba-edit-base-layout">
    <layout-header
      class="layout-header"
      v-bind="currConfig.header"
    >
      <slot name="header" />
    </layout-header>
    <div
      ref="layoutContent"
      class="layout-content"
    >
      <slot name="content" />
    </div>
    <layout-footer
      v-if="withFooter"
      class="layout-footer"
    >
      <slot name="footer" />
    </layout-footer>

    <back-to-top @to-top="onToTop" />
  </div>
</template>

<script>
import LayoutHeader from '@components/create-header'
import LayoutFooter from '@components/create-footer'
import BackToTop from '@components/back-to-top'

export default {
  name: 'MbaEditBaseLayout',
  components: { LayoutHeader, LayoutFooter, BackToTop },
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    withFooter: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  computed: {
    currConfig () {
      const currConfig = {
        header: {
          title: '页面标题',
          ...this.config.header
        }
      }

      return currConfig
    }
  },
  created () {},
  methods: {
    onToTop () {
      this.$refs.layoutContent.scrollTop = 0
    }
  }
}
</script>

<style lang='scss' scoped>
.mba-edit-base-layout {
  display: flex;
  flex-direction: column;
  height: 100%;

  .layout-content {
    flex: 1;
    padding: 20px;
    overflow: auto;
  }
}
</style>
